<template>
  <div class="common-header">
    <!-- 왼쪽: 뒤로가기 -->
    <div class="left"
        @click="$emit('clickBack')">
      <v-btn
        v-if="isShowBackBtn"
        icon
        depressed
        class="btn-back"
      >
        <v-icon dark>mdi-arrow-left</v-icon>
      </v-btn>
    </div>

    <!-- 가운데: 타이틀 -->
    <div class="center">
      <img v-if="headTitle === 'HOME'" class="top-logo" src="@/assets/images/common/header_home.png" alt="app_logo" width="40%" />
      <h2 v-else-if="propsTitle === '회원가입'">ZPT 카카오채널 가입 신청</h2>
      <h2 v-else>{{ headTitle }}</h2>
    </div>

    <!-- 오른쪽: 햄버거 -->
    <div class="right">
      <v-btn
        v-if="isShowLoginBtn && $route.fullPath !== '/tempChangePassword'"
        icon
        depressed
        class="btn-hamburger"
        @click="$emit('clickHamburger')"
      >
        <v-icon dark>mdi mdi-menu</v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isShowBackBtn: {
      type: Boolean,
      default: false,
    },
    propsTitle: {
      type: String,
      default: "",
    },
    headTitle: {
      type: String,
      default: "",
    },
    isShowLoginBtn: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss">
.common-header {
  position: fixed;   /* 상단 고정 */
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;     /* 다른 요소들 위에 표시 */
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100px;
  background-color: #d9f0d4;
  border-radius: 0 0 24px 24px;
  padding: 0 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.left,
.right {
  width: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.center {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  min-width: 320px;
}

.center h2 {
  margin: 0;
  font-size: 24px;
  font-weight: bold;
  color: $primary-color;
}
</style>
